import React, { useState } from 'react';
import { FaWhatsapp, FaTimes, FaHeadset, FaQuestionCircle, FaEnvelope } from 'react-icons/fa';
import { useSettings } from '../contexts/SettingsContext';

const SupportModal = ({ isOpen, onClose }) => {
  const { settings } = useSettings();
  const [selectedOption, setSelectedOption] = useState(null);
  
  const whatsappNumber = settings?.contactInfo?.whatsappSupportNumber || '9711533444';
  
  const supportOptions = [
    {
      id: 'general',
      title: 'General Support',
      description: 'Get help with orders, payments, and general questions',
      icon: <FaHeadset className="text-primary" size={24} />,
      whatsappMessage: 'Hi! I need general support with the food ordering app.'
    },
    {
      id: 'technical',
      title: 'Technical Issues',
      description: 'Report bugs, app problems, or technical difficulties',
      icon: <FaQuestionCircle className="text-warning" size={24} />,
      whatsappMessage: 'Hi! I\'m experiencing technical issues with the food ordering app.'
    },
    {
      id: 'order',
      title: 'Order Support',
      description: 'Help with order status, delivery, or order modifications',
      icon: <FaEnvelope className="text-success" size={24} />,
      whatsappMessage: 'Hi! I need help with my food order.'
    }
  ];

  const handleWhatsAppClick = (option) => {
    const message = encodeURIComponent(option.whatsappMessage);
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${message}`;
    window.open(whatsappUrl, '_blank');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="support-modal-overlay" onClick={onClose}>
      <div className="support-modal" onClick={(e) => e.stopPropagation()}>
        <div className="support-modal-header">
          <h3 className="support-modal-title">
            <FaHeadset className="me-2" />
            Customer Support
          </h3>
          <button className="support-modal-close" onClick={onClose}>
            <FaTimes />
          </button>
        </div>
        
        <div className="support-modal-body">
          <p className="support-modal-subtitle">
            Choose how we can help you today. We'll connect you with our support team via WhatsApp.
          </p>
          
          <div className="support-options">
            {supportOptions.map((option) => (
              <div 
                key={option.id}
                className={`support-option ${selectedOption === option.id ? 'selected' : ''}`}
                onClick={() => setSelectedOption(option.id)}
              >
                <div className="support-option-icon">
                  {option.icon}
                </div>
                <div className="support-option-content">
                  <h4 className="support-option-title">{option.title}</h4>
                  <p className="support-option-description">{option.description}</p>
                </div>
              </div>
            ))}
          </div>
          
          {selectedOption && (
            <div className="support-action">
              <button 
                className="btn btn-success btn-lg w-100 d-flex align-items-center justify-content-center gap-2"
                onClick={() => handleWhatsAppClick(supportOptions.find(opt => opt.id === selectedOption))}
              >
                <FaWhatsapp size={20} />
                Contact Support via WhatsApp
              </button>
              <p className="support-note">
                You'll be redirected to WhatsApp with a pre-filled message. Our support team will respond within 24 hours.
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default SupportModal; 